import React, { useState } from 'react'
import { Container, Form, Tabs, Tab, Button, Row, Col } from 'react-bootstrap'
import { CATEGORIES_COLLECTION, serverTimestamp } from '../../firebase'
import { v4 as uuidv4 } from 'uuid'
import { useHistory } from 'react-router'
import urlSlug from 'url-slug'

const INITIAL_STATE = {
    _id: '',
    category: '',
    date: serverTimestamp.now(),
    title_en: '',
    title_sr: ''
}

const AddCategory = () => {

    const history = useHistory()

    const [add, setAdd] = useState(INITIAL_STATE)

    const handleAdd = async (e) => {

        e.preventDefault();

        const _id = uuidv4();

        await CATEGORIES_COLLECTION.doc(_id).set({
            _id: _id,
            category: urlSlug(add.title_en),
            date: add.date,
            title_en: add.title_en,
            title_sr: add.title_sr
        })
            .then(() => {
                alert("Uspješno dodano 👍")
                history.push('/preview-category')
            })
            .catch((error) => {
                alert(error.message)
            })
    }

    return (
        <>
            <div>
                <Container>
                    <Tabs defaultActiveKey="add-category" className="mb-3" transition={false}>
                        <Tab eventKey="preview-category" title={<div onClick={() => history.push('/preview-category')}>Pregled kategorija</div>} />
                        <Tab eventKey="add-category" title="Dodaj">
                            <Form onSubmit={handleAdd}>
                                <Row>
                                    <Col lg={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Naslov (EN)</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Unesite - Naslov (EN)"
                                                value={add.title_en}
                                                onChange={(e) => { setAdd({ ...add, title_en: e.target.value }) }}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col lg={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Naslov (SR)</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Unesite - Naslov (SR)"
                                                value={add.title_sr}
                                                onChange={(e) => { setAdd({ ...add, title_sr: e.target.value }) }}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <Button variant="primary" type="submit">
                                            Dodaj
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Tab>
                        <Tab eventKey="edit-category" title='Uredi' disabled />
                        <Tab eventKey="delete-category" title='Obriši' disabled />
                    </Tabs>
                </Container>
            </div>
        </>
    )
}

export default AddCategory
